import { jsx as n, Fragment as C, jsxs as m } from "react/jsx-runtime";
import { forwardRef as v } from "react";
const f = "_inputContainer_191vs_1", h = "_inputContainer__prependSlot_191vs_21", x = "_inputContainer__appendSlot_191vs_28", N = "_input_191vs_1", t = {
  inputContainer: f,
  inputContainer__prependSlot: h,
  inputContainer__appendSlot: x,
  input: N
}, g = v(function({
  id: o,
  placeholder: r,
  type: _ = "text",
  value: s,
  required: u,
  disabled: i,
  isError: p,
  prependSlot: a,
  appendSlot: e,
  onChange: d,
  ...l
}, c) {
  return /* @__PURE__ */ n(C, { children: /* @__PURE__ */ m(
    "div",
    {
      className: t.inputContainer,
      "data-error": p,
      "data-disabled": i,
      children: [
        a && /* @__PURE__ */ n("div", { className: t.inputContainer__prependSlot, children: a }),
        /* @__PURE__ */ n(
          "input",
          {
            id: o,
            ref: c,
            className: t.input,
            placeholder: r,
            type: _,
            defaultValue: s,
            onChange: d,
            required: u,
            disabled: i,
            "data-error": p,
            "data-has-prepend-slot": !!a,
            "data-has-append-slot": !!e,
            ...l
          }
        ),
        e && /* @__PURE__ */ n("div", { className: t.inputContainer__appendSlot, children: e })
      ]
    }
  ) });
});
export {
  g as I
};
